import React from "react";
import type { StyleProp, TextStyle, ViewStyle } from "../platformComponents";
import { Keyboard, Text, TouchableOpacity, StyleSheet } from "../platformComponents";
import { colors, baseStyles } from "../styles/common";
import { tranformPx } from "@adgm/libs";

interface IProps {
  onPress?: () => void;
  disable?: boolean;
  text: string | undefined;
  style?: StyleProp<ViewStyle>;
  mode?: "fill" | "stroke";
  textStyle?: StyleProp<TextStyle>;
  testID?: string;
  accessibilityLabel?: string;
  enableBackgroundColor?: string;
}
const styles = StyleSheet.create({
  button: {
    height: tranformPx(56),
    alignItems: "center",
    justifyContent: "center",
    borderRadius: tranformPx(1),
  },

  text: {
    ...baseStyles.fontBold,
    fontSize: tranformPx(16),
    lineHeight: tranformPx(24),
  },
});

/**
 * 项目中常见的通用按钮
 * @param props
 * @constructor
 */
export function CommonButton(props: IProps) {
  const {
    onPress,
    disable = false,
    text,
    style,
    textStyle,
    mode = "fill",
    testID,
    accessibilityLabel,
    enableBackgroundColor,
  } = props;

  const enableTextColor = colors.mainTextColor;
  const disableTextColor = colors.grey7;
  const _enableBackgroundColor = enableBackgroundColor || colors.highlightColor;
  const disableBackgroundColor = colors.white7;

  const themeColor = disable ? disableBackgroundColor : _enableBackgroundColor;

  let backgroundColor;
  let textColor;
  const borderColor = themeColor;

  if (mode === "fill") {
    backgroundColor = themeColor;
    textColor = disable ? disableTextColor : enableTextColor;
  } else {
    backgroundColor = "transparent";
    textColor = themeColor;
  }

  return (
    <TouchableOpacity
      accessibilityLabel={accessibilityLabel}
      activeOpacity={disable ? 1 : 0.8}
      disabled={disable}
      onPress={
        disable
          ? undefined
          : () => {
              Keyboard.dismiss();
              onPress && onPress();
            }
      }
      style={[
        styles.button,
        {
          backgroundColor,
        },
        mode === "fill"
          ? null
          : {
              borderColor,
              borderWidth: tranformPx(1),
            },
        style,
      ]}
      testID={testID}>
      <Text
        style={[
          styles.text,
          {
            color: textColor,
          },
          textStyle,
        ]}>
        {text}
      </Text>
    </TouchableOpacity>
  );
}
